/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { ButtonGroup, Card, Col, Container, Row } from "react-bootstrap"
import { useLocation, useNavigate } from "react-router"
import { Button } from "../../components"
import { GetFacilityDetail } from "../../utilities/api/Facilities"
import { FacilityDetailType } from "../../utilities/types"
import { ArchiveFacilities } from "./ArchiveFacilities"
import { ToastContainer, toast } from "react-toastify"

const FacilitiesInfo = () => {

    const [archive, setArchive] = useState(false);
    const location = useLocation()
    const navigate = useNavigate()
    const [facilityDetails, setFacilityDetails] = useState<FacilityDetailType>()

    const GetInfo = async () => {
        const result = await GetFacilityDetail(location.state)
        if (result.statusCode === 200) {
            setFacilityDetails(result.data)
        } else {
            toast.error(result.response.data.message);
        }
    }
    useEffect(() => {
        GetInfo()
    }, [])

    const handleEdit = () => {
        navigate("/update-facility", { state: facilityDetails?.id })
    }
    return (
        <Container fluid className="g-0">
            <Card>
                <Card.Body>
                    <div className="page-title align-items-center d-flex justify-content-between">
                        <Card.Title className="mb-0">Facility Details </Card.Title>
                        <ButtonGroup>
                            <Button onClick={() => setArchive(true)} type="button" bname="Delete Facility" name="delete-facility" id="delete-facility" className="btn btn-light rounded-1 me-3"></Button>
                            <Button onClick={handleEdit} type="button" bname="Edit Facility" name="edit-facility" id="edit-facility" className="btn btn-primary rounded-1"></Button>
                        </ButtonGroup>
                    </div>
                    <h4 className="card-title2 text-start fs-2 fw-semibold d-flex align-items-center">{facilityDetails?.name} <span className="badges ms-2 rounded-pill text-success badges-success">{facilityDetails?.isActive ? "Active" : "Inactive"}</span></h4>
                    <hr />
                    <Row>

                        <Col lg={"8"}>
                            <div className="facility-details">
                                <Row className="text-start row-mb">
                                    <Col lg={"12"}>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Sports</span>
                                        <span className="user-info">
                                            {facilityDetails?.facilitySports?.length ? facilityDetails?.facilitySports.map((item: any) => {
                                                return (
                                                    <span className="badges bg-light me-2 rounded-pill">{item.sport.name}</span>
                                                )
                                            }) : <span className="badges me-2 rounded-pill text-bg-danger">No Sport</span>}
                                        </span>
                                    </Col>
                                </Row>
                                <Row className="text-start row-mb">
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Address</span>
                                        <span className="user-info">{facilityDetails?.address.addressLine1} {facilityDetails?.address.addressLine2}</span>
                                    </Col>
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Landmark</span>
                                        <span className="user-info">{facilityDetails?.address.landmark || "-"}</span>
                                    </Col>
                                </Row>
                                <Row className="text-start row-mb" >
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Pincode</span>
                                        <span className="user-info">{facilityDetails?.address.pincode}</span>
                                    </Col>
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">City</span>
                                        <span className="user-info">{facilityDetails?.address.city}</span>
                                    </Col>
                                </Row>
                                <Row className="text-start row-mb" >
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">State</span>
                                        <span className="user-info">{facilityDetails?.address.state}</span>
                                    </Col>
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Country</span>
                                        <span className="user-info">{facilityDetails?.address.country}</span>
                                    </Col>
                                </Row>
                                <Row className="text-start row-mb" >
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Latitude</span>
                                        <span className="user-info">{facilityDetails?.address.latitude || "-"}</span>
                                    </Col>
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Longitude</span>
                                        <span className="user-info">{facilityDetails?.address.longitude || "-"}</span>
                                    </Col>
                                </Row>
                                <Row className="text-start row-mb">
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Created by</span>
                                        <span className="user-info">{facilityDetails?.createdByUser?.firstName} {facilityDetails?.createdByUser?.lastName}</span>
                                    </Col>
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Created at</span>
                                        <span className="user-info">{facilityDetails?.createdAt}</span>
                                    </Col>
                                </Row>
                                <Row className="text-start row-mb">
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Updated by</span>
                                        <span className="user-info">{facilityDetails?.updatedByUser?.firstName} {facilityDetails?.updatedByUser?.lastName}</span>
                                    </Col>
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Updated at</span>
                                        <span className="user-info">{facilityDetails?.updatedAt}</span>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <ArchiveFacilities setArchive={setArchive} archive={archive} id={facilityDetails?.id} />
            <ToastContainer />
        </Container>
    )
}

export { FacilitiesInfo }
